// Mock data for SMX Medical website

export const services = [
  {
    id: 1,
    title: "Event Medical Cover",
    description: "Full-spectrum medical package tailored to meet the unique needs of your event, ensuring safety and wellbeing.",
    icon: "Ambulance",
    features: [
      "Comprehensive pre-event planning",
      "Tailored medical plan creation",
      "On-site medical and first aid coverage",
      "Minimizing impact on local healthcare services"
    ]
  },
  {
    id: 2,
    title: "Repatriation",
    description: "Bespoke repatriation service for the injured and unwell patient with dedicated road and air support.",
    icon: "Plane",
    features: [
      "Dedicated road repatriation service",
      "Commercial flight patient escort",
      "Specialized medical transport",
      "Professional care throughout journey"
    ]
  },
  {
    id: 3,
    title: "Patient Transport",
    description: "Specially designed multi-role ambulances providing safe transport for all patient types.",
    icon: "Users",
    features: [
      "Walking patient transport",
      "Wheelchair accessible vehicles",
      "Stretcher patient capability",
      "Fully equipped ambulances"
    ]
  },
  {
    id: 4,
    title: "Medical Training",
    description: "High-quality, hands-on training delivered by experienced professionals to individuals and organisations.",
    icon: "GraduationCap",
    features: [
      "Accredited training courses",
      "Experienced instructors",
      "Practical skills development",
      "Flexible scheduling options"
    ]
  }
];

export const trainingCourses = [
  {
    id: 1,
    title: "First Aid (1 Day)",
    duration: "1 Day",
    description: "Comprehensive one-day first aid training covering essential life-saving skills for individuals and organisations.",
    topics: [
      "The role of the first aider",
      "Dealing with an unresponsive casualty",
      "CPR and AED use",
      "Choking management",
      "Wound care and bleeding control"
    ],
    available: true
  },
  {
    id: 2,
    title: "First Aid (3 Days)",
    duration: "3 Days",
    description: "Comprehensive three-day first aid training for higher-risk environments. In-depth coverage of emergency medical scenarios.",
    topics: [
      "Advanced first aid techniques",
      "Fractures and spinal injuries",
      "Burns and scalds",
      "Medical emergencies",
      "Secondary survey",
      "Poisons and anaphylaxis"
    ],
    available: true
  },
  {
    id: 3,
    title: "AED Training",
    duration: "Half Day",
    description: "Automated External Defibrillator training to confidently use life-saving equipment in cardiac emergencies.",
    topics: [
      "Understanding cardiac arrest",
      "AED operation and safety",
      "CPR integration with AED use",
      "Hands-on practical sessions",
      "Emergency response protocols"
    ],
    available: true
  },
  {
    id: 4,
    title: "Oxygen Therapy",
    duration: "Half Day",
    description: "Training in the safe administration of emergency oxygen therapy for various medical conditions.",
    topics: [
      "Oxygen therapy fundamentals",
      "Equipment operation and safety",
      "Patient assessment",
      "Practical delivery techniques",
      "Legal and safety considerations"
    ],
    available: true
  },
  {
    id: 5,
    title: "Manual Handling",
    duration: "Half Day",
    description: "Essential manual handling techniques to prevent injury and ensure safe patient or load movement.",
    topics: [
      "Safe lifting techniques",
      "Risk assessment",
      "Posture and body mechanics",
      "Equipment usage",
      "Health and safety regulations"
    ],
    available: true
  },
  {
    id: 6,
    title: "First Response Emergency Care (FREC 3)",
    duration: "5 Days",
    description: "Advanced pre-hospital emergency care qualification for first responders. Comprehensive clinical skills training.",
    topics: [
      "Patient assessment and management",
      "Trauma care",
      "Medical emergencies",
      "Cardiac conditions",
      "Advanced airway management",
      "Clinical decision making"
    ],
    available: true
  },
  {
    id: 7,
    title: "First Response Emergency Care (FREC 4)",
    duration: "10 Days",
    description: "The highest level of pre-hospital care training. Equivalent to Ambulance Technician level qualification.",
    topics: [
      "All FREC 3 content plus:",
      "Advanced patient assessment",
      "Complex trauma scenarios",
      "Pharmacology",
      "Enhanced clinical interventions",
      "Multi-casualty incidents"
    ],
    available: true
  }
];

export const upcomingDates = [
  {
    courseId: 1,
    date: "2025-01-15",
    location: "Surrey Training Centre",
    spotsLeft: 8
  },
  {
    courseId: 2,
    date: "2025-01-20",
    location: "Sussex Training Centre",
    spotsLeft: 5
  },
  {
    courseId: 3,
    date: "2025-02-05",
    location: "Surrey Training Centre",
    spotsLeft: 10
  },
  {
    courseId: 1,
    date: "2025-02-12",
    location: "Sussex Training Centre",
    spotsLeft: 12
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Professional Medical Staff",
    role: "HCPC Paramedics & Ambulance Technicians",
    description: "Our team includes highly qualified professionals with frontline NHS experience."
  },
  {
    id: 2,
    name: "FREC-Certified Team",
    role: "First Response Emergency Care",
    description: "All team members are FREC-certified and undergo regular proficiency assessments."
  },
  {
    id: 3,
    name: "Enhanced DBS Checked",
    role: "Safety & Security Verified",
    description: "Every team member undergoes Enhanced DBS checks for your peace of mind."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Event Organizer",
    company: "Sussex Motorsports",
    rating: 5,
    text: "SMX Medical provided exceptional coverage for our event. Their professionalism and quick response gave us complete peace of mind."
  },
  {
    id: 2,
    name: "Festival Director",
    company: "Surrey Food Festival",
    rating: 5,
    text: "Outstanding service from start to finish. The team was friendly, professional, and well-equipped to handle any situation."
  }
];

export const partners = [
  {
    name: "Motorsport UK",
    logo: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=250,fit=crop/dJobQe0laqSVpB88/msuk1-AzGM3y42qzTGN1Mr.png",
    url: "https://www.motorsportuk.org/"
  },
  {
    name: "Qualsafe",
    logo: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=223,fit=crop/dJobQe0laqSVpB88/img_7951-KdKmtlX7iTn9w2jl.jpeg",
    url: "https://www.qualsafe.org/",
    note: "Registered Centre 908474"
  }
];

export const contactInfo = {
  phone: "01323 925 613",
  email: "contact@smxmedical.co.uk",
  social: {
    facebook: "https://www.facebook.com/share/1CHLAw5q1x/",
    instagram: "https://www.instagram.com/smx_medical"
  }
};

// Mock submission handlers
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Thank you for your inquiry. We'll get back to you soon!" });
    }, 1000);
  });
};

export const submitBookingInquiry = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Booking inquiry submitted:", bookingData);
      resolve({ success: true, message: "Booking inquiry received! We'll contact you shortly to confirm details." });
    }, 1000);
  });
};
